export const getLinePosition = (index: number, length: number) => {
  if (length === 1) {
    return "none";
  }
  return index === 0 ? "first" : index === length - 1 ? "last" : "middle";
};
